// @flow

import React from 'react'

type Props = {
  show: boolean,
  styles?: Object,
  arrowUp?: boolean,
  arrowDown?: boolean,
  colorClass?: string,
  arrowClass?: string,
  children?: React$Node,
  backgroundClass?: string,
}

const Tooltip = ({
  show,
  styles,
  children,
  arrowUp = true,
  colorClass = '',
  arrowClass = '',
  arrowDown = false,
  backgroundClass = '',
}: Props) => (
  <div
    className={`absolute z-5 mv0 mh center left-0 right-0 flex-column justify-center items-center text-center word-break ${
      show ? 'flex' : 'dn'
    }`}
    style={styles}
  >
    {arrowUp && <div className={`arrow-base arrow-up ${arrowClass}`}></div>}
    <div className={`pa2 ${colorClass} ${backgroundClass}`}>{children}</div>
    {arrowDown && <div className={`arrow-base arrow-down ${arrowClass}`}></div>}
  </div>
)

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/Controls/Tooltip.js